"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptExhaustedEvent = void 0;
class MessageAttemptExhaustedEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptExhaustedEvent.attributeTypeMap;
    }
}
exports.MessageAttemptExhaustedEvent = MessageAttemptExhaustedEvent;
MessageAttemptExhaustedEvent.discriminator = undefined;
MessageAttemptExhaustedEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "MessageAttemptExhaustedEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "MessageAttemptExhaustedEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptExhaustedEvent.js.map